import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import GtmSettingsPage from '@/pages/gtm-workspace/settings'
import { GTM_SETTINGS_TABS } from '@/features/gtm/workspace/gtm-settings-tabs'
import { requireGtmWorkspace } from '@/shared/lib/gtm-route-guard'

const searchSchema = z.object({
  project: z.string().uuid().optional(),
  /** The open settings tab; general when unset. */
  tab: z.enum(GTM_SETTINGS_TABS).optional().catch(undefined),
})

export const Route = createFileRoute(
  '/$lang/workspace/$workspaceId/gtm/settings',
)({
  validateSearch: (search) => searchSchema.parse(search),
  beforeLoad: ({ context, params }) => requireGtmWorkspace(context, params),
  component: GtmSettingsPage,
  staticData: { layout: 'main' },
})
